import {client} from './services/client'

export  const balance = {
    namespaced:true,
    state:{
        balance:[],
    },
    mutations: {
        SET_BALANCE (state,balance){
            state.balance = balance
        },

    },
    actions: {
        get({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/balance/get/'+id,
                })
                    .then((response)=>{
                        let balance = response.data.balance;
                        console.log(balance);
                        commit('SET_BALANCE',balance)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },

    },
    getters: {
        get: state  => {
            return state.balance
        },
    }
};
